export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loading . . ."])},
        "submit_answers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Submit"])},
        "errors": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please correct the following error(s):"])},
        "error_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["This field"])},
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Required"])}
      },
      "fr": {
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Chargement . . ."])},
        "submit_answers": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soumettre"])},
        "errors": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez corriger les erreurs suivantes:"])},
        "error_field": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cette valeur"])},
        "required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Obligatoire"])}
      }
    }
  })
}